import script from "./TextInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=18d8fb67&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18d8fb67"]])

export default __exports__